import { Form as FormikForm } from 'formik';
import styled, { css } from 'styled-components';
import { combineStrictCss } from '../../styling';
var StyledCss = /*#__PURE__*/css(["", ""], combineStrictCss());
/**
 * All React supported tags, minus some of the unnecessary ones. https://react-cn.github.io/react/docs/tags-and-attributes.html
 */

var A = /*#__PURE__*/styled.a.withConfig({
  displayName: "StyledElements__A",
  componentId: "sc-nr1cic-0"
})(["", ""], StyledCss);
var Address = /*#__PURE__*/styled.address.withConfig({
  displayName: "StyledElements__Address",
  componentId: "sc-nr1cic-1"
})(["", ""], StyledCss);
var Aside = /*#__PURE__*/styled.aside.withConfig({
  displayName: "StyledElements__Aside",
  componentId: "sc-nr1cic-2"
})(["", ""], StyledCss);
var B = /*#__PURE__*/styled.b.withConfig({
  displayName: "StyledElements__B",
  componentId: "sc-nr1cic-3"
})(["", ""], StyledCss);
var Blockquote = /*#__PURE__*/styled.blockquote.withConfig({
  displayName: "StyledElements__Blockquote",
  componentId: "sc-nr1cic-4"
})(["", ""], StyledCss);
var Body = /*#__PURE__*/styled.body.withConfig({
  displayName: "StyledElements__Body",
  componentId: "sc-nr1cic-5"
})(["", ""], StyledCss);
var Br = /*#__PURE__*/styled.br.withConfig({
  displayName: "StyledElements__Br",
  componentId: "sc-nr1cic-6"
})(["", ""], StyledCss);
var Button = /*#__PURE__*/styled.button.withConfig({
  displayName: "StyledElements__Button",
  componentId: "sc-nr1cic-7"
})(["", ""], StyledCss);
var Caption = /*#__PURE__*/styled.caption.withConfig({
  displayName: "StyledElements__Caption",
  componentId: "sc-nr1cic-8"
})(["", ""], StyledCss);
var Colgroup = /*#__PURE__*/styled.colgroup.withConfig({
  displayName: "StyledElements__Colgroup",
  componentId: "sc-nr1cic-9"
})(["", ""], StyledCss);
var Data = /*#__PURE__*/styled.data.withConfig({
  displayName: "StyledElements__Data",
  componentId: "sc-nr1cic-10"
})(["", ""], StyledCss);
var Datalist = /*#__PURE__*/styled.datalist.withConfig({
  displayName: "StyledElements__Datalist",
  componentId: "sc-nr1cic-11"
})(["", ""], StyledCss);
var Dd = /*#__PURE__*/styled.dd.withConfig({
  displayName: "StyledElements__Dd",
  componentId: "sc-nr1cic-12"
})(["", ""], StyledCss);
var Del = /*#__PURE__*/styled.del.withConfig({
  displayName: "StyledElements__Del",
  componentId: "sc-nr1cic-13"
})(["", ""], StyledCss);
var Details = /*#__PURE__*/styled.details.withConfig({
  displayName: "StyledElements__Details",
  componentId: "sc-nr1cic-14"
})(["", ""], StyledCss);
var Dialog = /*#__PURE__*/styled.dialog.withConfig({
  displayName: "StyledElements__Dialog",
  componentId: "sc-nr1cic-15"
})(["", ""], StyledCss);
var Div = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledElements__Div",
  componentId: "sc-nr1cic-16"
})(["", ""], StyledCss);
var Dl = /*#__PURE__*/styled.dl.withConfig({
  displayName: "StyledElements__Dl",
  componentId: "sc-nr1cic-17"
})(["", ""], StyledCss);
var Dt = /*#__PURE__*/styled.dt.withConfig({
  displayName: "StyledElements__Dt",
  componentId: "sc-nr1cic-18"
})(["", ""], StyledCss);
var Em = /*#__PURE__*/styled.em.withConfig({
  displayName: "StyledElements__Em",
  componentId: "sc-nr1cic-19"
})(["", ""], StyledCss);
var Fieldset = /*#__PURE__*/styled.fieldset.withConfig({
  displayName: "StyledElements__Fieldset",
  componentId: "sc-nr1cic-20"
})(["", ""], StyledCss);
var Footer = /*#__PURE__*/styled.footer.withConfig({
  displayName: "StyledElements__Footer",
  componentId: "sc-nr1cic-21"
})(["", ""], StyledCss);
/**
 * A styled Formik Form component that can take a $css prop. Should be wrapped in a `<Formik>`.
 */

var Form = /*#__PURE__*/styled(FormikForm).withConfig({
  displayName: "StyledElements__Form",
  componentId: "sc-nr1cic-22"
})(["", ""], StyledCss);
var H1 = /*#__PURE__*/styled.h1.withConfig({
  displayName: "StyledElements__H1",
  componentId: "sc-nr1cic-23"
})(["", ""], StyledCss);
var H2 = /*#__PURE__*/styled.h2.withConfig({
  displayName: "StyledElements__H2",
  componentId: "sc-nr1cic-24"
})(["", ""], StyledCss);
var H3 = /*#__PURE__*/styled.h3.withConfig({
  displayName: "StyledElements__H3",
  componentId: "sc-nr1cic-25"
})(["", ""], StyledCss);
var H4 = /*#__PURE__*/styled.h4.withConfig({
  displayName: "StyledElements__H4",
  componentId: "sc-nr1cic-26"
})(["", ""], StyledCss);
var H5 = /*#__PURE__*/styled.h5.withConfig({
  displayName: "StyledElements__H5",
  componentId: "sc-nr1cic-27"
})(["", ""], StyledCss);
var H6 = /*#__PURE__*/styled.h6.withConfig({
  displayName: "StyledElements__H6",
  componentId: "sc-nr1cic-28"
})(["", ""], StyledCss);
var Head = /*#__PURE__*/styled.head.withConfig({
  displayName: "StyledElements__Head",
  componentId: "sc-nr1cic-29"
})(["", ""], StyledCss);
var Header = /*#__PURE__*/styled.header.withConfig({
  displayName: "StyledElements__Header",
  componentId: "sc-nr1cic-30"
})(["", ""], StyledCss);
var Hr = /*#__PURE__*/styled.hr.withConfig({
  displayName: "StyledElements__Hr",
  componentId: "sc-nr1cic-31"
})(["", ""], StyledCss);
var I = /*#__PURE__*/styled.i.withConfig({
  displayName: "StyledElements__I",
  componentId: "sc-nr1cic-32"
})(["", ""], StyledCss);
var Iframe = /*#__PURE__*/styled.iframe.withConfig({
  displayName: "StyledElements__Iframe",
  componentId: "sc-nr1cic-33"
})(["", ""], StyledCss);
var Img = /*#__PURE__*/styled.img.withConfig({
  displayName: "StyledElements__Img",
  componentId: "sc-nr1cic-34"
})(["", ""], StyledCss);
var Input = /*#__PURE__*/styled.input.withConfig({
  displayName: "StyledElements__Input",
  componentId: "sc-nr1cic-35"
})(["", ""], StyledCss);
var Label = /*#__PURE__*/styled.label.withConfig({
  displayName: "StyledElements__Label",
  componentId: "sc-nr1cic-36"
})(["", ""], StyledCss);
var Legend = /*#__PURE__*/styled.legend.withConfig({
  displayName: "StyledElements__Legend",
  componentId: "sc-nr1cic-37"
})(["", ""], StyledCss);
var Li = /*#__PURE__*/styled.li.withConfig({
  displayName: "StyledElements__Li",
  componentId: "sc-nr1cic-38"
})(["", ""], StyledCss);
var Main = /*#__PURE__*/styled.main.withConfig({
  displayName: "StyledElements__Main",
  componentId: "sc-nr1cic-39"
})(["", ""], StyledCss);
var Menu = /*#__PURE__*/styled.menu.withConfig({
  displayName: "StyledElements__Menu",
  componentId: "sc-nr1cic-40"
})(["", ""], StyledCss);
var Menuitem = /*#__PURE__*/styled.menuitem.withConfig({
  displayName: "StyledElements__Menuitem",
  componentId: "sc-nr1cic-41"
})(["", ""], StyledCss);
var Nav = /*#__PURE__*/styled.nav.withConfig({
  displayName: "StyledElements__Nav",
  componentId: "sc-nr1cic-42"
})(["", ""], StyledCss);
var Ol = /*#__PURE__*/styled.ol.withConfig({
  displayName: "StyledElements__Ol",
  componentId: "sc-nr1cic-43"
})(["", ""], StyledCss);
var Option = /*#__PURE__*/styled.option.withConfig({
  displayName: "StyledElements__Option",
  componentId: "sc-nr1cic-44"
})(["", ""], StyledCss);
var P = /*#__PURE__*/styled.p.withConfig({
  displayName: "StyledElements__P",
  componentId: "sc-nr1cic-45"
})(["", ""], StyledCss);
var Section = /*#__PURE__*/styled.section.withConfig({
  displayName: "StyledElements__Section",
  componentId: "sc-nr1cic-46"
})(["", ""], StyledCss);
var Select = /*#__PURE__*/styled.select.withConfig({
  displayName: "StyledElements__Select",
  componentId: "sc-nr1cic-47"
})(["", ""], StyledCss);
var Span = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledElements__Span",
  componentId: "sc-nr1cic-48"
})(["", ""], StyledCss);
var Strong = /*#__PURE__*/styled.strong.withConfig({
  displayName: "StyledElements__Strong",
  componentId: "sc-nr1cic-49"
})(["", ""], StyledCss);
var Sub = /*#__PURE__*/styled.sub.withConfig({
  displayName: "StyledElements__Sub",
  componentId: "sc-nr1cic-50"
})(["", ""], StyledCss);
var Summary = /*#__PURE__*/styled.summary.withConfig({
  displayName: "StyledElements__Summary",
  componentId: "sc-nr1cic-51"
})(["", ""], StyledCss);
var Sup = /*#__PURE__*/styled.sup.withConfig({
  displayName: "StyledElements__Sup",
  componentId: "sc-nr1cic-52"
})(["", ""], StyledCss);
var Table = /*#__PURE__*/styled.table.attrs({
  role: 'table'
}).withConfig({
  displayName: "StyledElements__Table",
  componentId: "sc-nr1cic-53"
})(["display:block;", ""], StyledCss);
var Tbody = /*#__PURE__*/styled.tbody.attrs({
  role: 'rowgroup'
}).withConfig({
  displayName: "StyledElements__Tbody",
  componentId: "sc-nr1cic-54"
})(["display:block;", ""], StyledCss);
var Td = /*#__PURE__*/styled.td.attrs({
  role: 'cell'
}).withConfig({
  displayName: "StyledElements__Td",
  componentId: "sc-nr1cic-55"
})(["", ""], StyledCss);
var Textarea = /*#__PURE__*/styled.textarea.withConfig({
  displayName: "StyledElements__Textarea",
  componentId: "sc-nr1cic-56"
})(["", ""], StyledCss);
var Th = /*#__PURE__*/styled.th.attrs({
  role: 'columnheader'
}).withConfig({
  displayName: "StyledElements__Th",
  componentId: "sc-nr1cic-57"
})(["", ""], StyledCss);
var Thead = /*#__PURE__*/styled.thead.attrs({
  role: 'rowgroup'
}).withConfig({
  displayName: "StyledElements__Thead",
  componentId: "sc-nr1cic-58"
})(["display:block;", ""], StyledCss);
var Title = /*#__PURE__*/styled.title.withConfig({
  displayName: "StyledElements__Title",
  componentId: "sc-nr1cic-59"
})(["", ""], StyledCss);
var Tr = /*#__PURE__*/styled.tr.attrs({
  role: 'row'
}).withConfig({
  displayName: "StyledElements__Tr",
  componentId: "sc-nr1cic-60"
})(["", ""], StyledCss);
var U = /*#__PURE__*/styled.u.withConfig({
  displayName: "StyledElements__U",
  componentId: "sc-nr1cic-61"
})(["", ""], StyledCss);
var Ul = /*#__PURE__*/styled.ul.withConfig({
  displayName: "StyledElements__Ul",
  componentId: "sc-nr1cic-62"
})(["", ""], StyledCss);
export { A, Address, Aside, B, Blockquote, Body, Br, Button as StyledButton, Caption, Colgroup, Data, Datalist, Dd, Del, Details, Dialog, Div, Dl, Dt, Em, Fieldset as StyledFieldset, Footer as StyledFooter, Form, H1, H2, H3, H4, H5, H6, Head, Header as StyledHeader, Hr, I, Iframe, Img, Input as StyledInput, Label as StyledLabel, Legend as StyledLegend, Li, Main, Menu as StyledMenu, Menuitem, Nav, Ol, Option, P, Section, Select as StyledSelect, Span, Strong, Sub, Summary, Sup, Table, Tbody, Td, Textarea, Th, Thead, Title, Tr, U, Ul };